<template>
  <div class="skillResults">
    <div class="o-ndividualArea c-responsive-fixwidth skill-pad-adjust">
      <div class="o-ndividualTable">
        <div class="c-common-space o-individual-calls">
            <div class="row">
                <div class="col-sm-9">
                    <form class="form-inline">
                        <div class="form-group">
                            <label for="exampleInputEmail3">Sort By</label>
                            <select class="form-control" v-model="sortSkill" @change="sortSkills()">
                                <option value="name">Sort Alphabetically</option>
                                <option value="priotiy">Sort by Order/Priority</option>
                            </select>
                        </div>
                    </form>
                </div>
                <!-- #1999 — the panel-level "Skill Cache Refresh" switch is gone (ed, 2026-09-28 11:18 EDT):
                     it warmed the unversioned skill.employee:{client}:{skill} keys, which the assign page's
                     SkillRosterCache does not read. Editing an employee's skills reaches the assign page
                     through observer invalidation (SkillRosterCache::invalidate*); Super Admin has a
                     per-client "Refresh roster cache" for direct-database changes (#2000). -->
            </div>
        </div>

        <div class="o-skills-listing" v-loading="loadingSkillList">
            <div class="row">
                <div 
                    class="col col-sm-4 skill-listing-left" 
                    infinite-scroll-disabled="busy" 
                    infinite-scroll-distance="10"
                    v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                    ref="scrollContainer"
                    style="min-height: 1px;"
                >
                    <div v-for="(skill,key) in skills" :key="key" :class="(selectedSkillId==skill.id)?'o-skill-box skill-box-mod c-common-gradient c-common-box-shadow skill-box-selected':'o-skill-box skill-box-mod c-common-gradient c-common-box-shadow'">
                      <div class="skill-box-left">
                        <div @click="selectSkill(skill)" class="skill-title">{{(skill.name)? skill.name : "NA"}}</div>
                        <div class="skill-details">
                          <div class="skill-details-box">
                              <p><span>Employees</span></p>
                              <p>{{(skill.employee_count) ? skill.employee_count:'0'}}</p>
                          </div>
                          <div class="skill-details-box">
                              <p><span>Priority</span></p>
                              <p>{{skill.priotiy}}</p>
                          </div>
                          <div class="skill-details-box">
                              <p class="text-center"><span>Notify</span></p>
                              <p class="text-center" :class="getPower('notify')?'':'tabNotifyHide'"><a href="javascript: void(0)" @click="addBatchNotify(skill.id)" class="skill-notify-icon"><i class="fa fa-mobile" aria-hidden="true"></i></a></p>
                          </div>
                        </div>
                        <div class="skill-matric-feature">
                            <!-- #1999 — the per-skill "Cache For Speed" switch is gone: a roster is
                                 cached automatically at >= 750 employees (#1998), never by hand. -->
                            <div class="is-skip-last-next">
                                <label class="">Pass on Next-Last Metric:</label>
                                <el-switch
                                    style="display: inline"
                                    v-model="skill.is_skip_last_next"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="changeSkipLastNext(skill)">
                                </el-switch>
                            </div>
                        </div>
                      </div>
                      <div class="skill-box-right">
                        <div><i class="fa fa-user" @click="openSkillEmployeeModal(skill.id)" aria-hidden="true"></i></div>
                        <div :class="{'isDisabled':!getPower('editSkill')}"><i class="fa fa-pencil" aria-hidden="true" @click="openEditSkill(skill,key)"></i></div>
                        <div :class="{'isDisabled':!getPower('archiveSkill')}" v-if="checkDefaultSkillArchive(skill)"><i class="fa fa-archive" aria-hidden="true" @click="archiveSkill(skill.id)"></i></div>
                      </div>
                    </div>                    
                </div>

                <div class="col-sm-8">
                    <div class="skill-assign-holder c-common-gradient c-common-box-shadow" v-loading="employeeListLoad">
                
                        <div class="assign-employee-filter">
                            <div class="row">
                                <div class="col-sm-4">
                                    <label class="common-label-text">Status Level:</label>
                                    <div class="o-cutsomSelect o-cutsomSelect--inline">
                                        <select v-model="selectStatus" class="skill-select-mod" @change="getEmployeeWithStatusAndSkill()">
                                            <option v-for="(status,index) in employeeStatus" :key="index" :value="status.id"> {{status.name}} </option>
                                            <option value="all"> All </option>
                                        </select>                                   
                                    </div>
                                    <div class="instruction-text">
                                        Click Save BEFORE change in Status or Search
                                    </div>
                                </div>
                                
                                <div class="col-sm-4">
                                <p class="c-selected-skill-header"> {{selectedSkillName}} </p>
                                </div>
                                <div class="col-sm-4 text-right">
                                <a href="javascript: void(0)" :class="{'greyBg': userRoleSlug=='auditor'}" @click="updateSkillEmployees()" class="c-solid-btn btn-save-skill">Save</a>
                                </div>
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <div class="search-filter-skill">
                                        <div :class="{'isDisabled':!getPower('editSkill')}" class="btn-grp-skill">
                                            <label class="common-label-text">Select:</label>
                                            <a href="javascript: void(0)" @click="selectAllEmployee()" class="c-common-skill">All</a>
                                            <a href="javascript: void(0)" @click="selectNone()" class="c-solid-skill">None</a>
                                        </div>
                                        <div class="o-search-field search-inner-selector search-inner-skill">
                                            <div class="input-group stylish-input-group input-mod-skill">
                                                <input v-model="skillEmploySearch" @change="filterEmployeeList()" @input="filterEmployeeList()" type="text" placeholder="Search" class="form-control input-control-skill"> 
                                                <span class="input-group-addon">
                                                <button type="submit">
                                                        <span v-if="searchPattern">
                                                            <i aria-hidden="true" class="fa fa-close" @click="clearSkillEmploySearch"></i>
                                                        </span>
                                                        <span v-else>
                                                            <i aria-hidden="true" class="fa fa-search"></i>
                                                        </span>
                                                
                                                </button>
                                                </span>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    <div class="row">
                        <div class="emplisting-container">
                            <div v-if="employeeList.length">
                                <div v-for="(employee, key) in employeeList" :key="key" class="col-sm-6">
                                    <div class="assign-employee-list assign-emplisting-mod clearfix">
                                        <div class="checkbox o-custom-radio custom-radio-mod">
                                        <label v-if="employee">
                                            <span v-if="emp_sort == 'fname_desc'">{{employee.employable.last_name + ', ' + employee.employable.first_name }}</span>
                                            <span v-else>{{employee.employable.first_name + ' ' + employee.employable.last_name }}</span>
                                        <input type="checkbox" :id="selectedSkillId" :value="employee.skill_id" v-model="employee.skill_id" @change="changeEmployeeSkillArray(key,selectedSkillId,employee.skill_id)" :disabled="!getPower('editSkill')">
                                        <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                        </label>
                                        <!-- #1953 — right after the name, at the name's 14px, OUTSIDE the checkbox label so a star
                                             click does not untick the row. Ed, 2026-10-01 13:52 ("I can not seem to edit stars in the
                                             right hand pane"): a click now SAVES AT ONCE, like the Skill Employee List, with its own
                                             feedback — no page Save needed. Only for a ticked employee. The handler takes the rendered
                                             row object, never an index into another array. -->
                                        <skill-stars v-if="employee.skill_id && !hideSkillStars" size="14px" class="csk-row-stars" :value="Number(employee.skill_stars) || 0"
                                                     :disabled="!getPower('editSkill') || !!savingStars[employee.id]"
                                                     :testid="'skill-stars-' + employee.id" @input="saveStarsNow(employee, $event, selectedSkillId)" />
                                        <span v-if="starsFeedback[employee.id]" class="csk-feedback" :class="'csk-feedback--' + starsFeedback[employee.id].kind"
                                              :data-testid="'skill-stars-feedback-' + employee.id">{{ starsFeedback[employee.id].text }}</span>
                                        </div>
                                        <div class="assign-input-right">
                                        <input :class="{'isDisabled':!getPower('editSkill')}" type="number" @blur="changeEmployeeSkillArray(key,selectedSkillId,employee.skill_id)" class="form-control" placeholder="Seniority" v-model.number="employee.skill_seniority" @click="checkInput(key)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="no-job-dispaly">
                                <i class="fa fa-frown-o" aria-hidden="true"></i>
                                <br />
                                No Records Found
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <modal name="edit-skill"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
      <div class="modal-add-newJob" tabindex="-1" role="dialog">
         <div  role="document">
             <div class="modal-content o-common-modal-content">
                 <div class="modal-header u-no-border text-center">
                     <button @click="closeEditSkill()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                     <h4 class="modal-title">Edit Skill</h4>
                 </div>
                 <div class="modal-body c-common-box-shadow o-modal-body">
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Skill Name:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                   <input type="text" class="form-control" :disabled="checkDefaultSkillEditName(addSkill.name)" placeholder="Text Input"  v-validate="{required: true}" name="name" v-model="addSkill.name">
                                <span v-show="errors.has('name') && this.validation_err == 1" class="err-msg">{{ errors.first('name') }}</span>
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Sort Priority:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                           <input type="text" class="form-control" placeholder="Text Input" v-model="addSkill.priotiy">
                                 </label>
                             </div>
                         </div>
                     </div>

                     <!-- #2081 — flag off: master's five fixed inputs. Flag on: one input per live rate table, by table id. -->
                     <template v-if="!rateTablesOn">
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate A:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_a">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate B:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_b">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate C:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_c">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate D:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_d">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate E:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_e">
                                 </label>
                             </div>
                         </div>
                     </div>
                     </template>
                     <template v-else>
                         <div class="row" v-for="t in rateTablesList" :key="'rt' + t.table_id">
                             <div class="col-sm-12 o-modal-field-area">
                                 <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                     <label class="common-label-text common-label-text--modalwidth rt-label">{{ t.alias }}:</label>
                                 </div>
                                 <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                     <label class="common-label-input--modalwidth o-custom-dropdown">
                                        <input type="text" class="form-control rt-amount" placeholder="Rate($)" :data-table-id="t.table_id" v-model="editAmounts[t.table_id]">
                                     </label>
                                 </div>
                             </div>
                         </div>
                     </template>

                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Description:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                   <textarea placeholder="Text Area" v-model="addSkill.description" class="form-control" rows="6" v-validate="{required: true}" name="description"></textarea>
                                     <span v-show="errors.has('description') && this.validation_err == 1" class="err-msg">{{ errors.first('description') }}</span>
                                     </label>
                             </div>
                         </div>
                     </div>
                 </div>
                 <div class="modal-footer text-center">
                     <ul class="o-filter-area">
                         <li>
                             <a href="javascript: void(0)" @click="closeEditSkill()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                         </li>
                         <li>
                             <a href="javascript: void(0)" @click="editSkill()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                         </li>
                     </ul>
                 </div>
             </div>
             <!-- /.modal-content -->
         </div>
         <!-- /.modal-dialog -->
     </div>
    </modal>

    <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
      <div class="modal-add-newJob" tabindex="-1" role="dialog">
          <div  role="document">
              <div class="modal-content o-common-modal-content">
                  <div class="modal-header u-no-border text-center o-small-modal-head">
                      <button @click="closeBatchNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <h4 class="modal-title">Batch Notify</h4>
                  </div>
                  <div class="modal-body c-common-box-shadow o-modal-body" v-loading.this.lock="lockNotify">
                      <div class="row">

                          <div class="col-sm-12">
                            <div class="col-sm-12">
                                <label class="common-label-text common-label-text-block">Message:</label>
                                <div class="o-sms-counter">{{sms.length}}/60</div>
                                <textarea maxlength="60" class="form-control o-margin-bottom10" v-model="sms" rows="5" placeholder="Enter your message here"></textarea>
                            </div>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer text-center">
                      <ul class="o-filter-area">
                          <li>
                              <a href="javascript: void(0)" @click="closeBatchNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                          </li>
                          <li>
                              <a href="javascript: void(0)" @click="sendNotify()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                          </li>
                      </ul>
                  </div>
              </div>
              <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
      </div>
    </modal>

    <modal name="skill-employee-modal" height="auto" width="60%" :scrollable="true" class="modal-dialog modal-sm">
        <div class="modal-add-newJob" tabindex="-1" role="dialog">
            <div  role="document">
                <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center">
                        <button type="button" @click="closeSkillEmployee()" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">{{ employeeSkillDetailsTitle + ' '}} Skill Employee List</h4>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">

                        <div class="row">
                            <div class="col-sm-12">
                                
                                <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                    <div class="table-responsive o-no-margin-bottom">
                                    <table id="skill-employee-details" class="table table-bordered o-demo-table o-no-margin-bottom">
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Seniority</th>
                                            <th>Skill Seniority</th>
                                            <th v-if="!hideSkillStars">Stars</th>   <!-- #2033 -->
                                            <th>Status</th>
                                            <th>Phone</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(emp, inx) in skillEmployee" :key="inx">
                                            <td>{{inx+1}}</td>
                                            <td>{{emp.first_name+' '+emp.last_name}}</td>
                                            <td>{{ emp.email }}</td>
                                            <td>{{ getRoundOffSkillSeniority(emp.employee_seniority) }}</td>
                                            <td>{{ getRoundOffSkillSeniority(emp.skill_seniority) }}</td>
                                            <!-- #1953 (ed, 2026-09-30 21:50: "get the edit to the stars working on those grids") — editable here too,
                                                 at the row's font size. This grid has no Save button, so a click persists at once through the
                                                 same updateEmployeeSkills row the main grid saves (seniority carried through unchanged). -->
                                            <td v-if="!hideSkillStars"><skill-stars size="inherit" :value="Number(emp.skill_stars) || 0" :disabled="!getPower('editSkill') || !!savingStars[emp.id]"
                                                             :testid="'skill-stars-list-' + emp.id" @input="saveStarsNow(emp, $event, exportSkillId)" />
                                                <span v-if="starsFeedback[emp.id]" class="csk-feedback" :class="'csk-feedback--' + starsFeedback[emp.id].kind">{{ starsFeedback[emp.id].text }}</span></td>
                                            <td>{{emp.name}}</td>
                                            <td>{{ emp.phone_number?emp.phone_number:'' }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    <!-- <div class="o-emp-csv-download"><strong>- OR -</strong> Download sample <a href="static/assets/download/sample-skill.csv" download class="o-csv-download"><i class="fa fa-download" aria-hidden="true"></i></a></div> -->
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-sm-12">
                                <hr class="o-modal-separetor" />
                            </div>
                        </div> -->
                        <!-- <div class="row">
                            <div class="col-sm-12">
                                <div class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                    <button class="btn c-common-btn c-common-btn--small c-common-btn--green o-csv-upload">Choose File</button>
                                    <input class="" type="file" name="myfile" @change="uploadCSV($event)"/>
                                    
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="modal-footer text-center">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="closeSkillEmployee()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a @click="exportData()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-download"></i> Export Data (.csv)</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </modal>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    import * as rt from '../../rateTables';   // #2081
    import SkillStars from '../employees/skillStars.vue';
    export default {
        components: {
            VueEditor,
            SkillStars,
        },
        props: ['myProp'],
        // #2081 — the parent passes `rates` (its getRates feed) as an attribute, not a prop,
        // so the root element keeps master's DOM with the flag off; read it from $attrs.

        watch: {
            async myProp(newVal) {
                if (typeof newVal == "object") {
                    await this.getAllSkillS();
                } else {
                    if (newVal == "") {
                        await this.getAllSkillS();
                    } else {
                        if (newVal.length > 1) {
                            this.loadingSkillList=true;
                            this.skills = [];
                            this.storeMore = [];
                            this.next_page = "";
                            await service.get('skill/searchSkills', {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                    'skillSearch': newVal
                                })
                                .then((res) => {
                                    this.searchData = res.data.result;
                                    this.skills = [];
                                    this.employees = [];
                                    for (var i = 0; i < this.searchData.length; i++) {
                                        if (this.searchData[i].archived == 0) {
                                            this.skills.push(this.searchData[i]);
                                        }
                                    }
                                    this.selectSkill(this.skills[0]);
                                    this.loadingSkillList=false;
                                }).catch((err) => {
                                    console.log(err);
                                    this.loadingSkillList=false;
                                })
                        }
                    }
                }
            }
        },

        computed: {
            // #2033 — the Owner Options switch. `clientData` is the client record getClient()
            // fetches; absent/NULL/0 all mean SHOWN.
            hideSkillStars() {
                return Number(this.clientData && this.clientData.hide_skill_stars) === 1;
            },
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID",
                getNotificationType: 'getNotificationType',
                userRoleSlug: 'userRoleSlug'
            }),
            rateTablesOn() {   // #2081
                return rt.tablesOn(this.$attrs.rates);
            },
            rateTablesList() {   // #2081 — live tables in position order
                return rt.liveTables(this.$attrs.rates);
            },
            filterEmployee() {
                if(!this.skillEmploySearch || this.skillEmploySearch == '')
                    return this.employees;

                return this.employees.filter((employee) => ((employee.employable&&employee.employable.first_name && employee.employable.first_name.toLowerCase().indexOf(this.skillEmploySearch.toLowerCase())!=-1) || (employee.employable&&employee.employable.last_name && employee.employable.last_name.toLowerCase().indexOf(this.skillEmploySearch.toLowerCase())!=-1)  ));
            }
        },

        data() {
            return {
                timerState: null,
                polling:null,
                employeeSkillDetailsTitle: '',
                clientData: null,
                emp_sort: '',
                tempSelectStatus: null,
                searchPattern: false,
                employeeList: [],
                employeeListLoad: false,
                global_skills_updated: [],
                skill_id_selected: '',
                skills: [],
                lockNotify: false,
                loadingSkillList:false,
                loadmoreloading:false,
                afterApi:false,
                total: 0,
                storeMore: [],
                page_no: 3,
                sortSkill: 'name',
                addSkill: {
                    'name': "",
                    'priotiy': "",
                    'description': "",
                    'client_id': '',
                    'rate_a': '',
                    'rate_b': '',
                    'rate_c': '',
                    'rate_d': '',
                    'rate_e': ''
                },
                next_page: "",
                search_query: "",
                validation_err: 0,
                status_message: "",
                skill_id: 0,
                skill_key: 0,
                lockEmployees: false,
                employeeStatus: [],
                selectStatus: null,
                selectedSkillId:'',
                selectedSkillName:'',
                loading: false,
                selectSkillId: '',
                selectedFilter: null,
                selectedEmpId: [],
                skillEmploySearch:'',
                employees:[],
                skillEmployee:[],
                savingStars: {},          // #1953 — employee id → true while a star click is saving
                starsFeedback: {},        // #1953 — employee id → {kind: 'saving'|'saved'|'error', text} beside the stars, briefly
                exportSkillId: null, // #1717
                editAmounts: {},     // #2081 — {table_id: amount} the edit modal edits (flag on only)
                sms:'',
                notifyTab: 'email',
                notifySkillID: [],
                
                attachment : null,
            }
        },

        async beforeMount() {
            await this.getAllSkillS();
        },

        async mounted() {
            await this.getClient()
        },
        async created() {

        },
        methods: {
            async changeSkipLastNext(skill) {
                let formData = {
                    is_skip_last_next: skill.is_skip_last_next
                };
                await service.post(`skill/${skill.id}/updateSkillSkipNextLast`, formData, {
                    'Authorization': this.userToken
                }).then((res) => {
                    // #1759 — same envelope check as the archive/edit paths: a 200
                    // with status_code '0' is a refusal, not a save.
                    if (!this.apiSucceeded(res)) {
                        this.$notify({
                            title: this.$t('error'),
                            message: this.serverMessage(res, 'This setting could not be updated.'),
                            type: 'error'
                        });
                        return;
                    }
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Updated Successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: this.errorMessage(err, 'This setting could not be updated.'),
                        type: 'error'
                    });
                });
            },
            async getClient(){
                await service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.clientData = res.data.result;
                    this.emp_sort = this.clientData.default_employee_sort                
                }).catch((err) => {
                    console.log(err);
                });        
            },

            // #1759 — these MUST match SkillController's list exactly. They did not:
            // the client tested 'rss feed' and 'penalty rules' while the server
            // refuses 'rss-feed' and 'penalty and rules'. So for those two the UI
            // SHOWED the archive button, the server refused, and the bare .then()
            // reported success — 10 live 'penalty and rules' rows are in that state
            // on production today. Single source of truth, spelled the server's way.
            defaultSkillNames() {
                return ['steward', 'rss-feed', 'dispatched by', 'penalty and rules'];
            },

            isDefaultSkillName(skillName) {
                return this.defaultSkillNames().indexOf(
                    String(skillName || '').trim().toLowerCase()
                ) !== -1;
            },

            checkDefaultSkillArchive(skill) {
                return !this.isDefaultSkillName(skill && skill.name);
            },

            checkDefaultSkillEditName(skillName) {
                return this.isDefaultSkillName(skillName);
            },

            openSkillEmployeeModal(id){
                this.skillEmployee = [];
                this.employeeSkillDetailsTitle = '';
                this.exportSkillId = id; // #1717 — remember the skill for the CSV export
                this.$modal.show('skill-employee-modal');
                let header = {
                    'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'clientId': this.userClientID,
                        'skillId': id
                }

               if(this.emp_sort != '') {
                    header.sort = this.emp_sort;
                }else {
                    header.sort = 'fname_asc';
                }

               service.get('employee/getEmployeeSkillDetails', header)
               .then((res) => {
                    this.skillEmployee=res.data.result;
                    this.employeeSkillDetailsTitle = res.data.result && res.data.result.length && res.data.result[0].skill_name ? res.data.result[0].skill_name:''
                }).catch(err =>{
                    console.log(err);
                });
            },

            closeSkillEmployee(){
                this.$modal.hide('skill-employee-modal');
            },

            // #1953 — a star click on EITHER /skills grid saves immediately: one
            // updateEmployeeSkills row, the same shape the page Save sends (skill kept,
            // seniority carried through, stars = the click; 0 clears). `emp` is the
            // rendered row object itself (main grid: an `employees` entry with
            // `employable`; modal: a flat getEmployeeSkillDetails row), never an index
            // into another array. Every other copy of the person is updated so the
            // grids, and a later page Save, cannot overwrite the rating with a stale one.
            personName(emp) {
                const p = emp.employable || emp;
                return ((p.first_name || '') + ' ' + (p.last_name || '')).trim();
            },
            feedback(id, kind, text, ms) {
                this.$set(this.starsFeedback, id, { kind, text });
                if (ms) setTimeout(() => { const f = this.starsFeedback[id]; if (f && f.kind === kind) this.$delete(this.starsFeedback, id); }, ms);
            },
            saveStarsNow(emp, n, skillId) {
                if (!this.getPower('editSkill') || this.userRoleSlug == 'auditor' || !skillId) return;
                n = n || 0;
                const before = Number(emp.skill_stars) || 0;
                this.$set(this.savingStars, emp.id, true);
                this.$set(emp, 'skill_stars', n);
                this.feedback(emp.id, 'saving', 'Saving…', 0);
                service.post('employee/updateEmployeeSkills', {
                    'status_id': this.selectStatus,
                    'skill_id': skillId,
                    'skill_employee': [{ id: emp.id, skill_id: skillId, name: this.personName(emp), skill_seniority: emp.skill_seniority, skill_stars: n }],
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then(() => {
                    this.$delete(this.savingStars, emp.id);
                    this.feedback(emp.id, 'saved', n ? 'Saved ' + n + '★' : 'Cleared', 2500);
                    this.$notify({ title: 'Saved', message: (n ? n + ' star' + (n === 1 ? '' : 's') : 'Rating cleared') + ' for ' + this.personName(emp), type: 'success', duration: 2000 });
                    // every other copy of this person, for this skill
                    if (skillId == this.selectedSkillId) {
                        (this.employees || []).forEach((e) => { if (e.id === emp.id && e !== emp) this.$set(e, 'skill_stars', n); });
                        (this.global_skills_updated || []).forEach((e) => { if (e.id === emp.id) this.$set(e, 'skill_stars', n); });
                    }
                    if (skillId == this.exportSkillId) {
                        (this.skillEmployee || []).forEach((e) => { if (e.id === emp.id && e !== emp) this.$set(e, 'skill_stars', n); });
                    }
                }).catch((err) => {
                    this.$delete(this.savingStars, emp.id);
                    this.$set(emp, 'skill_stars', before);
                    this.feedback(emp.id, 'error', 'Not saved', 4000);
                    this.$notify({ title: 'Not saved', message: (err && err.response && err.response.data && err.response.data.status_message) || 'The rating was not saved.', type: 'error' });
                });
            },

            // #1717 — iOS-proof export. The old path built a `data:text/csv` URI +
            // hidden `<a download>` which iOS Safari ignores (and caps by size), so
            // it never downloaded on iPad. Instead fetch a short-lived signed URL
            // and navigate to it; the server streams a real CSV attachment.
            async exportData(){
                if (!this.exportSkillId) { return; }
                try {
                    const res = await service.get(
                        'skill/export-employees-url?skillId=' + this.exportSkillId + '&sort=' + (this.emp_sort || 'fname_asc'),
                        {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }
                    );
                    const url = res && res.data && res.data.result && res.data.result.url;
                    if (url) {
                        // Trigger via a click on a hidden anchor so Chrome animates the
                        // download indicator from the button press (vs a bare navigation).
                        // The server's Content-Disposition sets the filename; still iOS-safe
                        // because it's a real HTTP response, not a data: URI.
                        const a = document.createElement('a');
                        a.href = url;
                        a.rel = 'noopener';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else { alert('Could not prepare the export. Please try again.'); }
                } catch (err) {
                    console.log('export error', err);
                    alert('Could not prepare the export. Please try again.');
                }
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            sendNotify(){
              var formData;
              if(this.sms != ''){
                formData = {
                    message: this.sms,
                    client_id: this.userClientID,
                    skill_id:this.notifySkillID[0],
                    user_id: this.userID
                };
                this.lockNotify=true;
                service.post('skill/notifyBySkill', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    this.lockNotify=false;
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Notify Successfully.',
                        type: 'success'
                    });
                    this.$modal.hide('batch-notify');
                }).catch((err) => {
                    console.log(err);
                    this.lockNotify=false;
                });
                
              }else{
                this.$notify.error({
                  title: this.$t('error'),
                  message: 'You cannot send a blank message.'
                });
              }
            },

            addBatchNotify(skillID) {
                this.notifySkillID = [];
                this.notifySkillID.push(skillID);
                this.sms="";
                this.$modal.show('batch-notify');
            },

            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },

            // #1759 — cs3's API answers HTTP 200 with status_code '0' for a REFUSAL
            // (the default-skill guards in SkillController do exactly this). axios
            // resolves a 200, so a bare .then() runs on failure and the UI claimed
            // success while nothing was saved. Every skill mutation below now asks
            // this before announcing anything.
            apiSucceeded(res) {
                return !!(res && res.data && String(res.data.status_code) === '1');
            },

            // The server's OWN reason, never "Something went wrong!".
            //
            // status_message is usually a string, but a Laravel validation failure
            // sends a MessageBag — an object of field -> [messages] — which renders
            // as "[object Object]" if passed straight to a toast. That is the shape
            // behind the name max:32 / description max:256 rejections in FS #15969,
            // so it is flattened rather than stringified.
            serverMessage(payload, fallback) {
                const data = payload && payload.data ? payload.data : payload;
                const msg = data && data.status_message;
                if (typeof msg === 'string' && msg.trim()) {
                    return msg;
                }
                if (msg && typeof msg === 'object') {
                    const flat = Object.keys(msg)
                        .reduce((acc, k) => acc.concat(msg[k]), [])
                        .filter((m) => typeof m === 'string' && m.trim());
                    if (flat.length) {
                        return flat.join(' ');
                    }
                }
                return fallback;
            },

            // An axios rejection (4xx/5xx) carries the same envelope under .response.
            errorMessage(err, fallback) {
                return this.serverMessage(err && err.response ? err.response : null, fallback);
            },

            getAllSkillS() {
                this.$Progress.start();
                this.storeMore = [];
                this.next_page = "";
                this.loadingSkillList=true;
                this.afterApi=false;
                service.get('skill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.skills = res.data.result.data;
                    this.sortSkills();
                    this.selectSkill(this.skills[0]);
                    this.selectStatus = this.skills[0];
                    this.employeeListLoad = true;
                    this.getEmployeeStatus();
                    this.loadingSkillList=false;
                    this.afterApi=true;
                    this.total = res.data.result.total;
                    this.$Progress.finish();
                    this.next_page = res.data.result.next_page_url;
                    if (this.next_page != null || this.next_page == "") {
                        this.loadmoreloading=true;
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((more) => {
                            this.storeMore = more.data.result.data;
                            this.next_page = more.data.result.next_page_url;
                            this.loadmoreloading=false;
                        }).catch((err) => {
                            console.log(err);
                            this.loadmoreloading=false;
                        });
                    }
                    
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loadingSkillList=false;
                    this.afterApi=true;
                });
                this.addSkill.client_id = this.userClientID;
            },

            async handleScroll() {
                // v-infinite-scroll already gates on busy + distance before firing
                // this handler, so no extra position check is needed. The previous
                // `if (position !== "bottom") return;` referenced an undefined global,
                // which threw a silent ReferenceError and left the list frozen on
                // page 1 — typically stopping near "Dispatched by" alphabetically.
                await this.loadMore();
            },

            async loadMore() {
                var arr = this.skills;
                if (this.storeMore.length != 0) {
                    this.storeMore.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.storeMore = [];
                    if (this.next_page != null || this.next_page != "") {
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((res) => {
                            this.storeMore = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    } else
                        this.storeMore = [];
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },

            sortSkills() {
                if (this.sortSkill == "name") {
                    this.skills.sort(function(a, b) {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    })
                } else {
                    this.skills.sort(function(a, b) {

                        if (a.priotiy < b.priotiy) return -1;
                        if (a.priotiy > b.priotiy) return 1;
                        return 0;
                    })
                }
                this.selectSkill(this.skills[0]);
            },

            addNewSkill() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;

                        service.post('skill', this.addSkill, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                            })
                            .then((res) => {
                                // #1759 — same envelope check as edit/archive.
                                if (!this.apiSucceeded(res)) {
                                    const reason = this.serverMessage(res, 'This skill could not be added.');
                                    this.status_message = reason;
                                    this.$notify({
                                        title: this.$t('error'),
                                        message: reason,
                                        type: 'error'
                                    });
                                    return;
                                }
                                this.status_message = res.data.status_message;
                                setTimeout(() => {
                                    this.$modal.hide('add-skill');
                                }, 500);
                                this.$notify({
                                    title: this.$t('success'),
                                    message: 'Skill Added Successfully.',
                                    type: 'success'
                                });
                                this.getAllSkillS();
                            }).catch((err) => {
                                console.log(err);
                                // Was a bare console.log: a duplicate name or an
                                // over-length field failed in total silence.
                                const reason = this.errorMessage(err, 'This skill could not be added.');
                                this.status_message = reason;
                                this.$notify({
                                    title: this.$t('error'),
                                    message: reason,
                                    type: 'error'
                                });
                            })

                    } else
                        this.validation_err = 1;

                });
            },

            addSkillModal() {
                this.addSkill['name'] = "";
                this.addSkill['description'] = "";
                this.addSkill['priotiy'] = "";
                this.status_message = "";
                this.addSkill.rate_a = '';
                this.addSkill.rate_b = '';
                this.addSkill.rate_c = '';
                this.addSkill.rate_d = '';
                this.addSkill.rate_e = '';
                this.$modal.show('add-skill');
            },

            closeAddSkill() {
                this.$modal.hide('add-skill');
            },

            openEditSkill(skill, key) {
                this.skill_key = key;
                this.status_message = "";
                // #1759 — set client_id HERE, where the edit payload is assembled.
                // It used to be set only as the last statement of getAllSkillS(),
                // so the PUT was valid purely because the list happened to have
                // loaded first (the backend requires 'client_id' => required|in:...).
                // beforeMount() does call getAllSkillS(), so this does not reproduce
                // today — verified — but the correctness of one method's payload
                // should not depend on an unrelated method having run.
                this.addSkill.client_id = this.userClientID;
                this.addSkill.name = skill.name;
                this.addSkill.description = skill.description;
                this.addSkill.priotiy = skill.priotiy;
                let skill_rates = ['rate_a','rate_b','rate_c','rate_d','rate_e']
                for(let i=0;i<skill.skill_rates.length; i++) {
                    this.addSkill[skill_rates[i]]=skill.skill_rates[i].amount;
                }
                if (this.rateTablesOn) {
                    // #2081 — by table id from B's rate_table_amounts, never by position
                    this.editAmounts = rt.amountsFor(skill, this.rateTablesList);
                }
                this.skill_id = skill.id;
                this.$modal.show("edit-skill");
            },

            closeEditSkill() {
                this.$modal.hide('edit-skill');
            },

            /**
             * #2081 — flag off: the very object master sends. Flag on: the same fields with
             * `amounts: {table_id: amount}` in place of rate_a..e (B upserts per table and
             * mirrors a back-filled table onto its legacy row).
             */
            editSkillPayload() {
                if (!this.rateTablesOn) {
                    return this.addSkill;
                }
                const payload = Object.assign({}, this.addSkill);
                ['rate_a', 'rate_b', 'rate_c', 'rate_d', 'rate_e'].forEach((k) => { delete payload[k]; });
                payload.amounts = rt.amountsPayload(this.editAmounts);
                return payload;
            },
            
            editSkill() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        service.put('skill/' + this.skill_id, this.editSkillPayload(), {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        })
                        .then((res) => {
                            // #1759 — a 200 is not a save. Check the envelope before
                            // touching the local array or claiming success.
                            if (!this.apiSucceeded(res)) {
                                const reason = this.serverMessage(res, 'This skill could not be updated.');
                                this.status_message = reason;
                                // Deliberately NOT mutating this.skills here: showing
                                // the new name in the list for a change the server
                                // refused is what made the failure invisible. The
                                // modal stays open so the reason is actionable.
                                this.$notify({
                                    title: this.$t('error'),
                                    message: reason,
                                    type: 'error'
                                });
                                return;
                            }

                            this.skills[this.skill_key].name = this.addSkill.name;
                            this.skills[this.skill_key].description = this.addSkill.description;
                            this.skills[this.skill_key].priotiy = this.addSkill.priotiy;
                            this.status_message = res.data.status_message;
                            this.getAllSkillS();
                            setTimeout(() => {
                                this.$modal.hide('edit-skill');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Skill Updated Successfully.',
                                type: 'success'
                            });
                        }).catch((err) => {
                            console.log(err);
                            // #1759 — the server sends real reasons ("A skill named X
                            // already exists", name max:32, description max:256).
                            // "Something went wrong!" discarded all of them, which is
                            // what FS #15969 was left staring at.
                            const reason = this.errorMessage(err, 'Something went wrong!');
                            this.status_message = reason;
                            this.$notify({
                                title: this.$t('error'),
                                message: reason,
                                type: 'error'
                            });
                        })

                    } else
                        this.validation_err = 1;

                });
            },

            archiveSkill(skillId) {
                this.$confirm('This will permanently archive the skill. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$Progress.start();
                    service.get('skill/' + skillId + '/archiveASkill', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        // #1759 — archiveASkill() refuses default skills with HTTP 200
                        // + status_code '0'. The bare .then() announced success anyway,
                        // the refetch put the skill straight back in the list, and the
                        // user was left unable to tell whether the archive took. That
                        // is what Local 99 reported on FS #16431.
                        if (!this.apiSucceeded(res)) {
                            this.$message({
                                type: 'error',
                                message: this.serverMessage(res, 'This skill could not be archived.'),
                                duration: 6000
                            });
                            return;
                        }
                        this.$message({
                            type: 'success',
                            message: 'Archived Successfully.'
                        });
                        this.getAllSkillS();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                        // Previously the user saw NOTHING at all on a 4xx/5xx.
                        this.$message({
                            type: 'error',
                            message: this.errorMessage(err, 'This skill could not be archived.'),
                            duration: 6000
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Archive canceled.'
                    });
                });
            },
            
            getEmployeeStatus(){
              service.get('employee/employee_status', {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
                  'cs3-context-clientId': this.userClientID,
              }).
              then((res) => {
                  this.employeeStatus = res.data.result;
                  this.employeeStatus.sort(function(a, b) {
                      if (Number(a.priority) < Number(b.priority)) return -1;
                      if (Number(a.priority) > Number(b.priority)) return 1;
                      return 0;
                  });
                    this.selectStatus=this.employeeStatus[0].id;
                    this.getEmployeeWithStatusAndSkill();
              }).catch((err) => {
                  console.log(err);
              });
            },

            selectAllEmployee() {
                this.global_skills_updated = [];
                this.selectedFilter = 'all';
                let self = this;
                this.filterEmployee.forEach(function(emp) {
                    emp.skill_id=self.selectedSkillId;
                    emp.skill_seniority = emp.employee_skills&&emp.employee_skills.length?emp.employee_skills[0].seniority:null;
                    emp.skill_stars = emp.employee_skills&&emp.employee_skills.length?(Number(emp.employee_skills[0].stars)||0):0;   // #1953
                    self.global_skills_updated.push(emp);
                });
                this.employeeList = this.global_skills_updated;
            },

            selectNone() {
                this.global_skills_updated = [];
                this.selectedFilter = 'none';
                let self = this;
                this.filterEmployee.forEach(function(emp) {
                    emp.skill_id=null;
                    self.global_skills_updated.push(emp);
                });
                this.employeeList = this.global_skills_updated;
            },

            checkInput(index){
              if(this.employees[index].skill_seniority==0){
                this.employees[index].skill_seniority=null;  
              }
            },

            changeEmployeeSkillArray(index,skillId,value) {
                let global_index = this.global_skills_updated.findIndex((element) => element.id == this.filterEmployee[index].id);
                if(this.global_skills_updated.length && global_index !== -1) {
                    this.global_skills_updated[global_index].id = this.filterEmployee[index].id;
                    this.global_skills_updated[global_index].name = this.filterEmployee[index].employable.first_name + ' ' + this.filterEmployee[index].employable.last_name;
                    this.global_skills_updated[global_index].skill_id = value;
                    this.global_skills_updated[global_index].skill_seniority = this.filterEmployee[index].skill_seniority;                
                    this.global_skills_updated[global_index].skill_stars = this.filterEmployee[index].skill_stars || 0;   // #1953
                }else {
                    let tempObj = {
                        id: this.filterEmployee[index].id,
                        skill_id: value,
                        name: this.filterEmployee[index].employable.first_name + ' ' + this.filterEmployee[index].employable.last_name,
                        skill_seniority: this.filterEmployee[index].skill_seniority,
                        skill_stars: this.filterEmployee[index].skill_stars || 0,   // #1953 — 0 clears
                    };
                    this.global_skills_updated.push(tempObj);
                }
            },

            updateSkillEmployees(){
              if(this.userRoleSlug=='auditor') {
                return;
              }
              this.employeeListLoad = true;
              service.post('employee/updateEmployeeSkills',{
                'status_id':this.selectStatus,
                'skill_id':this.selectedSkillId,
                'skill_employee': this.global_skills_updated,

              }, {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
                  'cs3-context-clientId': this.userClientID,
              }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Skill Updated Successfully.',
                        type: 'success'
                    });
                    this.global_skills_updated = [];
                    this.getEmployeeWithStatusAndSkill();
              }).catch((err) => {
                  this.employeeListLoad = false;
                  console.log(err);
              });
            },
            
            selectSkill(skill){
                this.selectedSkillId=skill.id;
                this.selectedSkillName=skill.name;
                this.getEmployeeWithStatusAndSkill();
            },

            async getEmployeeWithStatusAndSkill(){
                this.employeeListLoad = true;
                let header = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }
                
                let payload = {
                    'skill_id':this.selectedSkillId,
                    'status_id':this.selectStatus,
                }
                if(this.emp_sort != '') {
                    payload.sort = this.emp_sort;
                }else {
                    payload.sort = 'fname_asc';
                }
                this.tempSelectStatus = this.selectStatus;
                if(this.skills!==[]&&this.selectStatus&&this.selectStatus!=""){
                    this.$Progress.start();
                    await service.post('employee/getEmployeeSkillSeniority', payload, header).then((res) => {
                        this.employees=res.data.result;
                        let self=this;
                        this.employees.forEach((emp) => {
                            emp.skill_id = emp.employee_skills && emp.employee_skills.length ? emp.employee_skills[0].skill_id : null;
                            emp.skill_seniority = emp.employee_skills && emp.employee_skills.length ? this.getRoundOffSkillSeniority(emp.employee_skills[0].seniority) : null
                            emp.skill_stars = emp.employee_skills && emp.employee_skills.length ? (Number(emp.employee_skills[0].stars) || 0) : 0;   // #1953
                        })
                    }).catch((err) => {
                        console.log(err);
                        this.employeeListLoad = false;
                    });  
                    this.employeeList = this.filterEmployee;
                }
                this.employeeListLoad = false;

            },

            getRoundOffSkillSeniority(seniorityVal) {     
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            async filterEmployeeList() {
                if(this.skillEmploySearch.length > 0) {
                    this.searchPattern = true;
                    if(this.selectStatus != 'all') {
                        let temp = this.selectStatus;
                        this.tempSelectStatus = temp;
                        this.selectStatus = "all"
                        if(this.skillEmploySearch.length == 1)
                            await this.getEmployeeWithStatusAndSkill();
                    } else {
                        this.searchPattern = true;
                        this.tempSelectStatus = 'all'
                    }                    
                } else {
                    this.searchPattern = false;
                    this.selectStatus = this.tempSelectStatus;
                    await this.getEmployeeWithStatusAndSkill();
                }               
                this.employeeList = this.filterEmployee;
            },
             
            async clearSkillEmploySearch() {
                this.skillEmploySearch = "";
                this.searchPattern = false;
                if(this.tempSelectStatus != null || this.tempSelectStatus != "")
                    this.selectStatus = this.tempSelectStatus;
                else this.selectStatus = 'all'
                await this.getEmployeeWithStatusAndSkill();
                this.employeeList = this.filterEmployee;
            }
        }
    }

</script>
<style scoped>
    /* #1953 — the stars share the name's line and font: inline, after the label, a little gap */
    .custom-radio-mod { display: flex; align-items: center; flex-wrap: wrap; }
    .csk-row-stars { margin-left: 8px; }
    .csk-feedback { margin-left: 6px; font-size: 12px; }
    .csk-feedback--saving { color: #6b6b6b; }
    .csk-feedback--saved { color: #2e9d63; font-weight: bold; }
    .csk-feedback--error { color: #d6453f; font-weight: bold; }
    .skill-matric-feature {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }
    .skill-matric-feature label {
        padding-right: 3px;
    }
    .cache-for-speed {
        padding: 5px 10px 3px 2px;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }
    .is-skip-last-next {
        padding: 5px 2px 3px 10px;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }
    .greyBg {
        background-color: #c5c5c5!important;
        cursor: not-allowed;
        color: #e1e1e1;
    }
    .instruction-text {
        color: #ff1010;
        font-size: 12px;
        font-weight: bold;
        padding-top: 10px;
    }
    .skill-seniority-input-span{
        display: inline-block;
        margin-left: 10px;
        width: 35%;
    }
    .remove-employee-skill-span{
        display: inline-block;
        margin-top: 10px;
        width: 10%
    }
    .employee-skill-list-width{
        width: 50%;
        display: inline-block;
    }

    .form-control-1 {
        display: block;
        float: right;
        width: 25%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        -webkit-transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
        -o-transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
    }
    .assign-employee-list ul li {
        width: 100%;
        float: left;
        padding: 5px 10px;
    }
    .assign-employee-list ul {
        overflow-x: hidden;
        overflow-y: scroll;
        margin: 20px -10px 10px;
        background: #F4F7F8;
        max-height: 350px;
    }

    .o-custom-radio{
        display: inline-block;
        margin-top: 9px;
        margin-bottom: 5px;
        margin-right: 5px;
    }
    .c-selected-skill-header{
        font-size: 21px;
        font-weight: 600;
        text-align:center;
        margin-top: 6px;
    }
    .skill-select-mod{
        width:130px;
    }
    @media screen and (min-width:1366px){
        .skill-select-mod{
        width:120px;
        }
    }
    .skill-pad-adjust{
        padding: 0;
    }
</style>
